import {
  GetModelPresetsByModelIdApiResponse,
  GetModelsInferencesByModelIdApiResponse,
} from "infra/api/generated/api";

export function mapPresetsToInferences(
  presets: GetModelPresetsByModelIdApiResponse["presets"]
): GetModelsInferencesByModelIdApiResponse["inferences"] {
  return presets.map(
    (preset: GetModelPresetsByModelIdApiResponse["presets"][0]) => ({
      images: [],
      modelId: preset.modelId,
      authorId: "",
      displayPrompt: preset.parameters.prompt,
      ownerId: preset.ownerId,
      userId: "",
      createdAt: preset.createdAt,
      id: preset.id,
      imagesNumber: 0,
      parameters: {
        ...preset.parameters,
        kind: "image",
        type: preset.parameters
          .type as GetModelsInferencesByModelIdApiResponse["inferences"][0]["parameters"]["type"],
      },
      status: "succeeded",
      privacy: "public",
      updatedAt: new Date().toISOString(),
    })
  );
}
